export type StoryScene = {
  id: string;
  image: string;
  text?: string;
};

export type InteractiveStory = {
  id: string;
  title: string;
  startSceneId: string;
  scenes: StoryScene[];
};

const storyImage = (fileName: string) =>
  `${process.env.PUBLIC_URL || ""}/story/forest-rescue/${fileName}`;

export const forestRescueStory: InteractiveStory = {
  id: "forest-rescue-team",
  title: "Forest Rescue Team",
  startSceneId: "scene-01",
  scenes: Array.from({ length: 26 }, (_, index) => {
    const pageNumber = String(index + 1).padStart(2, "0");
    const id = `scene-${pageNumber}`;

    return {
      id,
      image: storyImage(`${id}.jpg`),
    };
  }),
};
